
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router'
import _ from 'lodash'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'
import ActionCard from '../../landlordModule/adminActions/actionCard'
import { getNameUser } from '../../../functions/agent/agentModuleComponent/getNameUser'
import { getUnitAddress } from '../../../functions/agent/agentModuleComponent/getUnitAddres'
import { type User } from '../../../store/slices/userSlice'
import { type Unit } from '../../../store/slices/unitsSlice'
import { animationOptions, swalAttentionLeave, swalOptions, swalSuccess } from '../../../functions/swalOptions'
import Swal from 'sweetalert2'
import UseUserType from '../../../hooks/UseUserType'
import { updateStatusViewing } from '../../../store/actionsCreators/viewingActions/updateStatusViewing'
import { toUTCWithOffset } from '../../../functions/agent/date/toUTCWithOffset'
import { sendNotification } from '../../../functions/shared/notifications/sendNotification'
import { setWhereAfterToGo } from '../../../store/slices/modalSlice'
import { getCurrentDubaiDate } from '../../../functions/agent/date/getCurrentDubaiDate'
import { openChatByUserID } from '../../../store/actionsCreators/chatActions'
import { sendCustomNotification } from '../../../functions/shared/notifications/sendCustomNotification'
import { setFilterNavigate } from '../../../store/slices/scheduleSlice'

const iconText = 'Success'
export const optionsSuccess = {
    ...swalOptions('success'),
    ...{
        title: 'Approved!',
        html: 'You have successfully confirmed viewing',
        showConfirmButton: true,
        iconHtml: '<div  id="lottie-icon-success></div>',
        confirmButtonText: 'Got it',
        didOpen: async () => {
            const lottieContainer = document.getElementsByClassName('swal2-icon-content')?.[0]
            const pathLottie = await import(`../../../../src/animations/${iconText}.json`)
            if (lottieContainer != null) {
                lottie.loadAnimation({
                    container: lottieContainer,
                    renderer: 'svg',
                    ...{ ...animationOptions, animationData: pathLottie.default }
                })
            }
        }
    }
}
export default function ViewingActionsForOtherAgents(): JSX.Element {
    const { unitID, objectID: viewingID } = useParams()
    const { userType } = UseUserType()
    const viewings = useAppSelector((state: RootState) => state.viewings.viewings)
    const viewing = _.find(viewings, (viewing) => viewing.id === Number(viewingID))
    const currentUser = useAppSelector((state: RootState) => state.user.currentUser)
    const units = useAppSelector((state: RootState) => state.units.units)
    const unit = _.find(units, (unit) => unit.id === Number(unitID))
    const viewingStatuses = viewing?.attributes?.Statuses
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const userToConnect = Number(viewing?.attributes?.User?.data?.id)

    const nameUser = getNameUser(currentUser as User)
    const unitAdress = getUnitAddress(unit as Unit)


    const handleApproveClick = async (): Promise<void> => {
        const result = await swalAttentionLeave('Are you sure?');
        if (result.isConfirmed) {
            const request = await dispatch(
                updateStatusViewing({
                    viewID: viewingID,
                    status: 'Approved',
                    unitID,
                    viewing,
                    createdUserID: userToConnect,
                    isOtherAgent: 'Agent'
                })
            );

            if (request.success && request.response.data) {
                await sendNotification(
                    toUTCWithOffset(getCurrentDubaiDate()),
                    userToConnect,
                    request?.response?.data?.id,
                    'user-viewing-approved',
                    `Dear ,${nameUser} approved viewing on ${unitAdress}.`
                );
                const swalResult = await swalSuccess('Viewing approved successfully.');
                if (swalResult.isConfirmed) {
                    dispatch(setFilterNavigate('viewings'))
                    dispatch(setWhereAfterToGo("/agent/schedule"));
                    navigate(`/agent/modalView/viewing_modal/${unitID}/${viewingID}/agent_s_unit`);
                }
            }
        }
    };
    const handleRejectClick = async () => {
        const result = await swalAttentionLeave('Are you sure?');
        if (result.isConfirmed) {
            const request = await dispatch(
                updateStatusViewing({
                    viewID: viewingID as string,
                    status: 'Rejected',
                    unitID: unitID as string,
                    createdUserID: userToConnect,
                    viewing,
                    isOtherAgent: 'Agent'
                })
            );

            if (request.success && request.response.data) {
                await sendNotification(
                    toUTCWithOffset(getCurrentDubaiDate(), 1),
                    userToConnect,
                    request?.response?.data?.id,
                    'user-viewing-rejected',
                    `Dear, ${nameUser} rejected viewing on ${unitAdress}.`
                );
                const swalResult = await Swal.fire({
                    ...optionsSuccess,
                    title: "Rejected!",
                    html: "You have successfully rejected viewing "
                });
                if (swalResult.isConfirmed) {
                    dispatch(setFilterNavigate('viewings'))
                    dispatch(setWhereAfterToGo("/agent/schedule"));
                    navigate(`/agent/modalView/viewing_modal/${unitID ?? ''}/${viewingID ?? ''}/agent_s_unit`);
                }
            }
        }
    };

    return (
        <>
            <div className={'d-flex flex-column w-100'}>
                {
                    (viewingStatuses?.includes('In-process') || viewingStatuses?.includes('Rescheduled by agent')) &&
                    <ActionCard
                        title={'Approve'}
                        description={'Approve viewing'}
                        onClick={() => {
                            void handleApproveClick();
                        }}
                        icon={'check_circle'}
                        styles={'mb-3 mx-n3'}
                    />
                }
                {
                    ['Approved', 'In-process', 'Rescheduled by other agent', 'Rescheduled by agent'].includes(viewingStatuses?.[0] as string) &&
                    <ActionCard
                        title={'Reject'}
                        description={'Reject viewing'}
                        onClick={() => {
                            void handleRejectClick();
                        }}
                        icon={'cancel'}
                        styles={'mb-3 mx-n3'}
                    />
                }

                {['Approved', 'In-process', 'Rescheduled by agent'].includes(viewingStatuses?.[0] as string) &&
                    <ActionCard
                        title={'Reschedule'}
                        description={'Reschedule viewing'}
                        onClick={() => {
                            void swalAttentionLeave('Are you sure?').then(async (result: any) => {
                                if (result.isConfirmed) {
                                    dispatch(setFilterNavigate('viewings'))
                                    dispatch(setWhereAfterToGo("/agent/schedule"))
                                    void sendCustomNotification(userToConnect, 'Test Title',
                                        `Dear ,${nameUser} testing viewing on ${unitAdress}.`,
                                        `/agent/modalView/viewing_modal/${unitID}/${viewingID}/calendar`)
                                    navigate(`/agent/modal/reschedule_viewing_modal_from_agent/${unitID ?? '-'}/${viewingID ?? '-'}`)
                                }
                            }).catch(console.log)
                        }}
                        icon={'event_available'}
                        styles={'mb-3 mx-n3'}
                    />
                }
                <ActionCard
                    title={'Chat'}
                    description={'Chat any time about some details '}
                    onClick={
                        () => {
                            dispatch(openChatByUserID(userToConnect))
                                .then(({ id }: { id: any }) => {
                                    if (id != null) {
                                        navigate(`/${userType.toLowerCase()}/chats/${String(id)}`)
                                    }
                                })
                        }

                    }
                    icon={'mail'}
                    styles={'mb-3 mx-n3'}

                />
            </div>
        </>
    )
}
